import { Button, ButtonGroup, Flex, Heading, Text } from '@chakra-ui/react';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { routes } from '../../../../../constants/routes';
import { Icon } from '../../Icon/Icon';
import { LogoIcon } from '../../Logo/Logo';

export interface ErrorProps {
  /**
   * Title
   */
  title: React.ReactNode;
  /**
   * Description
   */
  description: React.ReactNode;
  /**
   * Error actions (buttons, links and other components)
   */
  actions?: React.ReactNode;
  /**
   * Is home button visible
   */
  homeButton?: boolean;
  /**
   * Is sorry image visible
   */
  logo?: boolean;
}

/**
 * Error info component
 */
const ErrorInfo = ({
  title,
  description,
  actions,
  homeButton = false,
  logo = false,
}: ErrorProps): ReactElement | null => {
  const { t } = useTranslation();
  return (
    <Flex justify="center" align="center" direction="column" textAlign="center" rowGap={6}>
      {logo && <LogoIcon w={20} h={20} />}
      <Heading as="h1" size="3xl">
        {title}
      </Heading>
      <Text as="div" fontSize="large">
        {description}
      </Text>
      <Flex direction="row" justify="center" mt={4}>
        <ButtonGroup size="md" variant="outline" spacing={2}>
          {homeButton && (
            <a href={routes.HOME} className="none">
              <Button
                colorScheme="red"
                variant="solid"
                opacity={0.9}
                px={8}
                mb={2}
                size="sm"
                rightIcon={
                  actions ? undefined : (
                    <Icon icon={faChevronRight} size="sm" style={{ marginLeft: '.5rem' }} />
                  )
                }
              >
                {t('global.home')}
              </Button>
            </a>
          )}
          {actions}
        </ButtonGroup>
      </Flex>
    </Flex>
  );
};

export default ErrorInfo;
